module.exports = new __parcel__URL__("brickouest.53fe3369.avif").toString();